import { API_BASE_URL } from "@/config";

export default {
  name: "SalaryDetailsForm",
  props: {
    getSavedSectionResponses: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      // Form fields
      client_funds_source: "",
      client_salary_day: null,
      client_basic_salary: 0,
      client_commission: 0,
      client_over_time: 0,
      client_other_allowance: 0,
      client_loan_repayments: 0,
      client_settled_debt: 0,
      client_tax_registered_ind: "",
      client_nett_salary: 0,
      client_rental_income: 0,
      client_municipal_payments: 0,
      client_child_maintenance: 0,
      client_other_income: 0,
      client_other_income_source: "",
      client_bond_rent_payments: 0,
      client_vehicle_repayments: 0,
      client_credit_card_payments: 0,
      client_overdraft_payments: 0,
      client_furniture_account_payments: 0,
      client_clothing_account_payments: 0,
      client_insurance_payments: 0,
      client_telephone_payments: 0,
      client_transport_costs: 0,
      client_food_entertainment_costs: 0,
      client_education_costs: 0,
      client_security_payments: 0,
      client_house_hold_expenses: 0,
      client_other_payments: 0,

      // Calculated fields
      total_nett_income: 0,
      total_expenses: 0,
      disposable_income: 0,

      questions: [],
      question_map: {},
      error_messages: {},

      client_funds_source_options: [
        { value: "SALARY", label: "Salary" },
        { value: "RENTALS", label: "Rentals" },
        { value: "INTEREST", label: "Interest" },
        { value: "INVESTMENT INCOME", label: "Investment Income" },
        {
          value: "PROCEEDS FROM OWN BUSINESS",
          label: "Proceeds from Own Business",
        },
        { value: "DIVIDENDS", label: "Dividends" },
        { value: "DONATIONS", label: "Donations" },
        { value: "PENSION", label: "Pension" },
        { value: "SOCIAL BENEFITS", label: "Social Benefits" },
        { value: "MAINTENANCE", label: "Maintenance" },
        { value: "COURT ORDER", label: "Court Order" },
        { value: "COMMISSIONS EARNED", label: "Commissions Earned" },
      ],
    };
  },
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },
  },
  methods: {
    validate_salary_day() {
      if (this.client_salary_day < 1) {
        this.client_salary_day = 1;
      } else if (this.client_salary_day > 31) {
        this.client_salary_day = 31;
      }
    },
    get_questions() {
      const TOKEN = localStorage.getItem("token");
      const GET_QUESTIONS_URL = `${API_BASE_URL}/verify_api/financial_information_api/get_salary_questions/`;

      $.ajax({
        url: GET_QUESTIONS_URL,
        method: "GET",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        beforeSend: () => {
          Swal.fire({
            text: "Fetching salary questions...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
          });
        },
        success: (response) => {
          Swal.close();
          this.questions = response.questions;

          // Map each question's api_form_field to its id
          this.questions.forEach((question) => {
            if (question.api_form_field) {
              this.question_map[question.api_form_field] = question.id;
            }
          });
          this.load_saved_responses();
        },
        error: () => {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to fetch salary questions. Please try again later.",
            confirmButtonText: "OK",
          });
        },
      });
    },

    calculate_tools() {
      const nett_salary = parseFloat(this.client_nett_salary) || 0;

      // Total Nett Income
      const rental_income = parseFloat(this.client_rental_income) || 0;
      const child_maintenance = parseFloat(this.client_child_maintenance) || 0;
      const other_income = parseFloat(this.client_other_income) || 0;

      this.total_nett_income = (
        nett_salary +
        rental_income +
        child_maintenance +
        other_income
      ).toFixed(2);

      // Calculate Total Expenses
      const bond_rent = parseFloat(this.client_bond_rent_payments) || 0;
      const vehicle = parseFloat(this.client_vehicle_repayments) || 0;
      const credit_card = parseFloat(this.client_credit_card_payments) || 0;
      const overdraft = parseFloat(this.client_overdraft_payments) || 0;
      const loan = parseFloat(this.client_loan_repayments) || 0;
      const furniture = parseFloat(this.client_furniture_account_payments) || 0;
      const clothing = parseFloat(this.client_clothing_account_payments) || 0;
      const insurance = parseFloat(this.client_insurance_payments) || 0;
      const municipal = parseFloat(this.client_municipal_payments) || 0;
      const telephone = parseFloat(this.client_telephone_payments) || 0;
      const transport = parseFloat(this.client_transport_costs) || 0;
      const food = parseFloat(this.client_food_entertainment_costs) || 0;
      const education = parseFloat(this.client_education_costs) || 0;
      const security = parseFloat(this.client_security_payments) || 0;
      const household = parseFloat(this.client_house_hold_expenses) || 0;
      const other_payments = parseFloat(this.client_other_payments) || 0;

      this.total_expenses = (
        bond_rent +
        vehicle +
        credit_card +
        overdraft +
        loan +
        furniture +
        clothing +
        insurance +
        municipal +
        telephone +
        transport +
        food +
        education +
        security +
        household +
        other_payments
      ).toFixed(2);

      // Calculate Disposable Income
      this.disposable_income = (
        parseFloat(this.total_nett_income) - parseFloat(this.total_expenses)
      ).toFixed(2);
    },

    validate_salary_form() {
      this.error_messages = {}; // Reset errors
      let firstInvalidField = null;

      this.questions.forEach((question) => {
        const field_name = question.api_form_field;
        if (!field_name) return;
        if (question.required && !this[field_name] && this[field_name] !== 0) {
          this.error_messages[field_name] = `${question.question} is required.`;
          if (!firstInvalidField) {
            firstInvalidField = field_name;
          }
        }
      });

      return {
        valid: Object.keys(this.error_messages).length === 0,
        firstInvalidField,
      };
    },

    submit_salary_details(section = null, customer_id = null) {
      // Handle case where section is a DOM event (from template click)
      if (
        section &&
        (section instanceof Event || section.type === "click" || section.target)
      ) {
        section = null;
      }

      if (!section) {
        const validation = this.validate_salary_form();
        if (!validation.valid) {
          if (
            validation.firstInvalidField &&
            this.$refs[validation.firstInvalidField]
          ) {
            this.$nextTick(() => {
              const el = this.$refs[validation.firstInvalidField];
              if (el && el.focus) {
                el.focus();
                el.scrollIntoView({ behavior: "smooth", block: "center" });
              }
            });
          } else {
            window.scrollTo({ top: 0, behavior: "smooth" });
          }
          console.error("Validation errors:", this.error_messages);
          Swal.fire({
            icon: "warning",
            title: "Incomplete Form",
            text: "Please complete all required fields before continuing.",
            confirmButtonText: "OK",
          });
          return;
        }
      }

      const TOKEN = localStorage.getItem("token");
      const SAVE_RESPONSES_URL = `${API_BASE_URL}/verify_api/financial_information_api/save_salary_details/`;

      let responses = [];

      if (section && Array.isArray(section.questions)) {
        // Collect responses from section.questions
        responses = section.questions.map((q) => ({
          question_id: q.question_id,
          answer: q.response?.toString() || "",
        }));
      } else {
        // Collect responses from component's own data fields
        Object.keys(this.$data).forEach((field_name) => {
          if (
            !this.question_map[field_name] ||
            field_name === "questions" ||
            field_name === "question_map" ||
            field_name === "error_messages" ||
            field_name === "total_nett_income" ||
            field_name === "total_expenses" ||
            field_name === "disposable_income"
          ) {
            return;
          }
          responses.push({
            question_id: this.question_map[field_name],
            answer: this[field_name]?.toString() || "",
          });
        });
      }

      const FORM_DATA = {
        workflow_id: this.workflow_id,
        responses: responses,
      };

      if (customer_id) {
        FORM_DATA.customer_id = customer_id;
      }

      $.ajax({
        url: SAVE_RESPONSES_URL,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify(FORM_DATA),
        beforeSend: () => {
          Swal.fire({
            text: "Saving salary details...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
          });
        },
        success: () => {
          Swal.close();
          if (section && customer_id) {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Salary details changed successfully!",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            this.$emit("validity-change", true);
          }
        },
        error: (xhr) => {
          Swal.close();
          let errorMessage =
            "Failed to save salary details. Please try again later.";
          if (xhr.responseJSON && xhr.responseJSON.error) {
            errorMessage = xhr.responseJSON.error;
          }
          Swal.fire({
            icon: "error",
            title: "Error",
            text: errorMessage,
            confirmButtonText: "OK",
          });
        },
      });
    },
    async load_saved_responses() {
      try {
        const responses = await this.getSavedSectionResponses("Salary Details");

        const idToField = {};
        Object.entries(this.question_map).forEach(([field, qid]) => {
          idToField[qid] = field;
        });

        if (Array.isArray(responses) && responses.length > 0) {
          responses.forEach((resp) => {
            const field = idToField[resp.question_id];
            if (field && Object.prototype.hasOwnProperty.call(this, field)) {
              this[field] = resp.answer;
            }
          });
        }
      } catch (error) {
        console.error("Error loading saved responses:", error);
      }
    },
    handle_submit() {
      this.save_responses();
    },
  },
  mounted() {
    if (this.$store.getters.get_user_role?.toLowerCase() === "customer") {
      this.get_questions();
    }
  },
  watch: {
    // Add watchers for fields that should trigger recalculation
    client_basic_salary() {
      this.calculate_tools();
    },
    client_commission() {
      this.calculate_tools();
    },
    client_over_time() {
      this.calculate_tools();
    },
    client_other_allowance() {
      this.calculate_tools();
    },
    client_settled_debt() {
      this.calculate_tools();
    },
    client_nett_salary() {
      this.calculate_tools();
    },
    client_rental_income() {
      this.calculate_tools();
    },
    client_child_maintenance() {
      this.calculate_tools();
    },
    client_other_income() {
      this.calculate_tools();
    },
    client_salary_day() {
      this.validate_salary_day();
    },
    client_bond_rent_payments() {
      this.calculate_tools();
    },
    client_vehicle_repayments() {
      this.calculate_tools();
    },
    client_credit_card_payments() {
      this.calculate_tools();
    },
    client_overdraft_payments() {
      this.calculate_tools();
    },
    client_loan_repayments() {
      this.calculate_tools();
    },
    client_furniture_account_payments() {
      this.calculate_tools();
    },
    client_clothing_account_payments() {
      this.calculate_tools();
    },
    client_insurance_payments() {
      this.calculate_tools();
    },
    client_municipal_payments() {
      this.calculate_tools();
    },
    client_telephone_payments() {
      this.calculate_tools();
    },
    client_transport_costs() {
      this.calculate_tools();
    },
    client_food_entertainment_costs() {
      this.calculate_tools();
    },
    client_education_costs() {
      this.calculate_tools();
    },
    client_security_payments() {
      this.calculate_tools();
    },
    client_house_hold_expenses() {
      this.calculate_tools();
    },
    client_other_payments() {
      this.calculate_tools();
    },
  },
};
